export const getLocationHostname = () => window.location.hostname;
export const getLocationSearch = () => window.location.search;
export const getUrlSearchParam = param => {
  const params = new URLSearchParams(getLocationSearch());
  return params.get(param) || "";
};